import React from 'react';
import { Button, Icon } from 'antd';

export const ToggleButton = ({ toggle }) => (
  <div className="add-control-button">
    <Button onClick={toggle}>
      <Icon type="plus" /> Ajouter un champ
    </Button>
  </div>
);

export default ToggleButton;



// WEBPACK FOOTER //
// ./src/components/Admin/ActivitiesManagement/ActivityEdit/AddControl/ToggleButton.js